<template>
  <v-img height="100%" :src="imgSrc" :gradient="gradient" />
</template>

<script>
import Vue from 'vue'

export default Vue.component("tj-tool-bar-bg", {
  props: {
    primary: {
      type: String,
      default: "#049"
    },

    secondary: {
      type: String,
      default: "#037"
    },

    dark: {
      type: String,
      default: "#001b34"
    },

    isDark: Boolean,

    centered: Boolean,

    
  },

  computed: {
    imgSrc(){
      return "/img/white-pix.png"
    },

    gradient(){
      const center = this.centered;
      const dark = this.isDark
      const c1 = dark? this.dark : center? this.secondary: this.primary;
      const c2 = dark? this.dark: this.primary;
      const c3 = dark? this.dark: this.secondary;
      const position = center? "50%": "25%"
      return `90deg, ${c1} 0%, ${c2} 50%, ${c3} 100%`
    }
  }
})
</script>
